<template>
  <v-tooltip v-if="hint" bottom max-width="300">
    <template #activator="{ on, attrs }">
      <v-icon
        :small="iconSize === 'small'"
        :x-small="iconSize === 'x-small'"
        :class="iconClass"
        :style="iconStyle"
        v-bind="attrs"
        v-on="on"
        :data-test="dataTest"
      >
        mdi-information-outline
      </v-icon>
    </template>
    <div v-if="tooltipTitle" class="font-weight-bold" style="font-size: 0.8125rem; margin-bottom: 4px">
      {{ tooltipTitle }}
    </div>
    <span class="hint-body" v-html="hint" />
  </v-tooltip>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * Shared info-icon + tooltip used across all dashboard tiles/cards.
 * Replaces the duplicated `<v-tooltip>` + `<v-icon>` + `<span class="hint-body">`
 * pattern previously copy-pasted into every dashboard component.
 */
@Component
export default class DashboardHint extends Vue {
  @Prop({ default: "" }) readonly hint!: string;
  @Prop({ default: "" }) readonly tooltipTitle!: string;
  @Prop({ default: "x-small" }) readonly iconSize!: "small" | "x-small";
  @Prop({ default: "grey--text" }) readonly iconClass!: string;
  @Prop({ default: "" }) readonly iconStyle!: string | Record<string, string>;
  @Prop({ default: "dashboard-hint-info-icon" }) readonly dataTest!: string;
}
</script>

<!--
  Unscoped on purpose: Vuetify renders tooltip content in a body-level overlay,
  outside this component's scope, so scoped styles would never reach it.
-->
<style>
.hint-body {
  display: block;
  line-height: 1.45;
  font-size: 12px;
}

.hint-body strong {
  font-weight: 600;
}

.hint-body .hint-note {
  display: block;
  margin-top: 5px;
  opacity: 0.75;
  font-size: 11px;
  font-weight: 400;
}
</style>
